import React from "react";
import "./Input.scss";
import Form from "react-bootstrap/Form";
import InputInfoIcon from "../Icons/InputInfoIcon.svg";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export interface InputProps {
  id?: string;
  labelId?: string;
  /** id for the wrapping Form.Group; when set with `id`, gives real label↔control association. */
  controlId?: string;
  type?: string;
  label?: string;
  isRequired? : boolean;
  placeholder?: string;
  name?: string;
  maxNumber?: string;
  /** min/step for number inputs (accessibility + native validation). */
  minNumber?: string | number;
  step?: string | number;
  ariaDescribedBy?: string;
  ariaInvalid?: boolean;
  /** forwarded to the underlying Form.Control so RHF setFocus/shouldFocusError works. */
  inputRef?: React.Ref<any>;
  infoMessage?: string;
  value?: any;
  infoIcon?: boolean;
  tooltipClassName?: string;
  maxlength?: number;
  isDisabled: boolean | false;
  onChange: (e: any) => void;
  onBlur?: (e: any) => void;
  inputClassName?: any;
  [key: string]: any;
}

const Input = (props: InputProps) => {
  const {
    id,
    controlId,
    type,
    labelId,
    infoIcon,
    tooltipClassName,
    isRequired = false,
    label,
    placeholder,
    name,
    ariaDescribedBy,
    ariaInvalid,
    inputRef,
    maxNumber,
    minNumber,
    step,
    value,
    maxlength,
    isDisabled,
    infoMessage,
    onChange,
    onBlur,
    inputClassName,
  } = props;

  return (
    <React.Fragment>
      <Form.Group controlId={controlId} id={controlId ? undefined : "form_group_id"}>
        <Form.Label id={labelId} htmlFor={controlId ? undefined : id}>
          {label}
          {isRequired && <span className="input-required">*</span>}
          {infoIcon && (
            <OverlayTrigger
              key="top"
              placement="top"
              overlay={
                <Tooltip className={`toolTipMessage ${tooltipClassName ?? ""}`}>
                  {infoMessage}
                </Tooltip>
              }
            >
              <button
                type="button"
                className="InputInfoIconButton"
                aria-label={
                  infoMessage
                    ? `More information: ${infoMessage}`
                    : "More information"
                }
              >
                <img
                  className="InputInfoIcon"
                  width={15}
                  src={InputInfoIcon}
                  alt=""
                  aria-hidden="true"
                />
              </button>
            </OverlayTrigger>
          )}
        </Form.Label>
        <Form.Control
          id={id}
          ref={inputRef}
          type={type}
          name={name}
          value={value}
          max={maxNumber}
          min={minNumber}
          step={step}
          autoComplete="off"
          disabled={isDisabled}
          maxLength={maxlength}
          placeholder={placeholder}
          className={inputClassName}
          onChange={(e) => onChange(e)}
          onBlur={onBlur}
          // NB: intentionally no native `required` — it would switch on browser
          // form validation for the ~12 legacy callers that render Input inside a
          // <form> without noValidate, blocking their existing JS submit path.
          // aria-required conveys the same thing to AT without changing behaviour.
          aria-required={isRequired || undefined}
          aria-invalid={ariaInvalid || undefined}
          aria-describedby={ariaDescribedBy}
          data-non-master-disabled={props["data-non-master-disabled"] ? true : undefined}
        />
      </Form.Group>
    </React.Fragment>
  );
};

export default Input;
